import { jsxs, jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import Lottie from "../../node_modules/.pnpm/lottie-react@2.4.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/lottie-react/build/index.es.js";
import { useToonPlayer } from "./useToonPlayer.js";
import buttonAnimation from "../../assets/toon/lottie/toon_button_reaction.json.js";
import { AnimatePresence } from "../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/components/AnimatePresence/index.js";
import { motion } from "../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
import Volume2 from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/volume-2.js";
import ChevronLeft from "../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/chevron-left.js";
function ToonIntro({ cards, onComplete, autoPlayAudio = false }) {
  const {
    currentPage,
    direction,
    isFirst,
    isLast,
    goNext,
    goPrev,
    playAudio
  } = useToonPlayer({ totalPages: cards.length, autoPlayAudio });
  const card = cards[currentPage];
  useEffect(() => {
    if (card == null ? void 0 : card.audioUrl) {
      playAudio(card.audioUrl);
    }
  }, [currentPage, card == null ? void 0 : card.audioUrl, playAudio]);
  const slideVariants = {
    enter: (dir) => ({
      x: dir === "right" ? 300 : -300,
      opacity: 0
    }),
    center: { x: 0, opacity: 1 },
    exit: (dir) => ({
      x: dir === "right" ? -300 : 300,
      opacity: 0
    })
  };
  return /* @__PURE__ */ jsxs("div", { className: "relative w-full max-w-[720px] md:max-w-[800px] mx-auto", children: [
    /* @__PURE__ */ jsxs("div", { className: "relative w-full min-h-[480px] overflow-hidden bg-white rounded-3xl shadow-xl", children: [
      /* @__PURE__ */ jsx(AnimatePresence, { mode: "wait", custom: direction, children: /* @__PURE__ */ jsxs(
        motion.div,
        {
          custom: direction,
          variants: slideVariants,
          initial: "enter",
          animate: "center",
          exit: "exit",
          transition: { duration: 0.3, ease: "easeInOut" },
          className: "flex flex-col items-center w-full px-8 py-8 pb-28",
          children: [
            (card == null ? void 0 : card.text) && /* @__PURE__ */ jsxs("div", { className: "relative w-full py-4 pl-16 pr-4 font-medium text-center text-gray-700 bg-gray-100 rounded-2xl text-base md:text-lg", children: [
              card.audioUrl && /* @__PURE__ */ jsx(
                "button",
                {
                  className: "absolute left-4 top-3 w-10 h-10 flex items-center justify-center rounded-xl bg-orange-400 hover:bg-orange-500 transition-colors",
                  onClick: () => playAudio(card.audioUrl),
                  children: /* @__PURE__ */ jsx(Volume2, { className: "w-5 h-5 text-white" })
                }
              ),
              card.text
            ] }),
            (card == null ? void 0 : card.imageUrl) && /* @__PURE__ */ jsx(
              "div",
              {
                className: "w-full md:w-[640px] h-[320px] bg-no-repeat bg-center mt-6 bg-contain",
                style: { backgroundImage: `url(${card.imageUrl})` }
              }
            )
          ]
        },
        currentPage
      ) }),
      isLast && /* @__PURE__ */ jsx(
        motion.button,
        {
          initial: { opacity: 0, scale: 0.95 },
          animate: { opacity: 1, scale: 1 },
          transition: { duration: 0.3, delay: 0.3, ease: "easeOut" },
          className: "absolute bottom-8 right-8 px-6 py-2 min-w-[120px] font-bold text-white bg-orange-400 rounded-2xl\n                [box-shadow:0px_4px_0px_#E88A1C,0px_8px_0px_rgba(0,0,0,0.2)]\n                hover:bg-orange-500 active:translate-y-1 active:[box-shadow:0px_2px_0px_#E88A1C] transition-all",
          onClick: onComplete,
          children: "완료"
        }
      )
    ] }),
    !isFirst && /* @__PURE__ */ jsx(
      "button",
      {
        onClick: goPrev,
        className: "absolute top-1/2 left-2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center\n              [box-shadow:0px_2px_0px_rgba(0,0,0,0.1)] hover:bg-gray-50 transition-colors",
        children: /* @__PURE__ */ jsx(ChevronLeft, { className: "w-6 h-6 text-gray-500" })
      }
    ),
    !isLast && /* @__PURE__ */ jsx(
      "button",
      {
        onClick: goNext,
        className: "absolute top-[calc(50%-20px)] -right-2 z-10",
        children: /* @__PURE__ */ jsx(
          Lottie,
          {
            animationData: buttonAnimation,
            loop: false,
            autoplay: true,
            style: { width: 80 }
          }
        )
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "flex justify-center gap-1.5 mt-4", children: cards.map((_, i) => /* @__PURE__ */ jsx(
      "div",
      {
        className: `w-2 h-2 rounded-full transition-colors ${i === currentPage ? "bg-orange-400" : "bg-lc-gray-300"}`
      },
      i
    )) })
  ] });
}
export {
  ToonIntro
};
//# sourceMappingURL=ToonIntro.js.map
